import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-17" }, null, -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_5 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_6 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_7 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"padding":"10px 10px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Status", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-1 ss-movimento-comercial-campo-totalizador" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Itens", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Total dos Produtos", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Frete", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1)
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_32 = { style: {"color":"white"} }
const _hoisted_33 = ["value"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "Sim", -1)
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = { class: "ant-col ant-col-xs-16 ant-col-xl-2" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "ant-col ant-col-xs-8 ant-col-xl-1" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_41 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_42 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_43 = {
  class: "ant-col",
  style: {"flex":"1 0 auto"}
}
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_47 = { class: "ant-row" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_modelo_documento_fiscal = _resolveComponent("selecionar-modelo-documento-fiscal")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_forma_pagamento = _resolveComponent("selecionar-forma-pagamento")!
  const _component_selecionar_marcador_nota_fiscal = _resolveComponent("selecionar-marcador-nota-fiscal")!
  const _component_devolucao_compras_itens = _resolveComponent("devolucao-compras-itens")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_documentos_referenciados = _resolveComponent("nota-fiscal-documentos-referenciados")!
  const _component_nota_fiscal_impostos = _resolveComponent("nota-fiscal-impostos")!
  const _component_nota_fiscal_frete = _resolveComponent("nota-fiscal-frete")!
  const _component_devolucao_compras_pagamento = _resolveComponent("devolucao-compras-pagamento")!
  const _component_nota_fiscal_dados_adicionais = _resolveComponent("nota-fiscal-dados-adicionais")!
  const _component_nota_fiscal_anexos = _resolveComponent("nota-fiscal-anexos")!
  const _component_nota_fiscal_historico = _resolveComponent("nota-fiscal-historico")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-compras' : 'scroll-modal ss-modal-compras'
  }, {
    title: _withCtx(() => [
      _createTextVNode("Devolução de Compras")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.props.operacao.tipoPermissaoDados != _ctx.EPermissaoDados.Visualizar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                ((_ctx.state.devolucao.codigo > 0))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.state.devolucao.status !== _ctx.EStatusDevolucaoCompras.Concluida && _ctx.state.devolucao.status !== _ctx.EStatusDevolucaoCompras.Cancelada)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 0,
                            placement: "top",
                            title: "Concluir Etapa"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.concluirEtapa && _ctx.concluirEtapa(...args)))
                              }, [
                                _createVNode(_component_icone, { nome: "check" })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.state.devolucao.status !== _ctx.EStatusDevolucaoCompras.EmDigitacao && _ctx.state.devolucao.status !== _ctx.EStatusDevolucaoCompras.Concluida && _ctx.state.devolucao.status !== _ctx.EStatusDevolucaoCompras.Cancelada)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 1,
                            placement: "top",
                            title: "Retornar Etapa"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.retornarEtapa && _ctx.retornarEtapa(...args)))
                              }, [
                                _createVNode(_component_icone, { nome: "rollback" })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.state.devolucao.status !== _ctx.EStatusDevolucaoCompras.Cancelada)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 2,
                            placement: "top",
                            title: "Cancelar"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                              }, [
                                _createVNode(_component_icone, { nome: "cancelar" })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.state.devolucao.status === _ctx.EStatusDevolucaoCompras.EmDigitacao)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 3,
                            placement: "top",
                            title: "Excluir"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                              }, [
                                _createVNode(_component_icone, { nome: "excluir" })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_tooltip, {
                        placement: "top",
                        title: "Imprimir"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
                          }, [
                            _createVNode(_component_icone, { nome: "imprimir" })
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.state.devolucao.status === _ctx.EStatusDevolucaoCompras.EmDigitacao)
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 4,
                            placement: "top",
                            title: "Salvar e Novo"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                type: "button",
                                class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.salvar(true)))
                              }, [
                                _createVNode(_component_icone, { nome: "adicionar-camada" })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.state.devolucao.codigo > 0 ? 'Salvar' : 'Continuar'), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 10 }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  style: _normalizeStyle('color: white; font-size: 11px; background-color: ' + _ctx.obterCorStatus(_ctx.state.devolucao.status) + '!important;'),
                  value: _ctx.obterDescricaoStatus(_ctx.state.devolucao.status),
                  disabled: "true"
                }, null, 12, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.state.devolucao.itens.length,
                  disabled: "true"
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.devolucao.notaFiscal.totalProdutos, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.devolucao.notaFiscal.totalDesconto, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.devolucao.notaFiscal.totalFrete, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.devolucao.notaFiscal.totalSeguro, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_24)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.devolucao.notaFiscal.totalOutrasDespesas, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_27)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("input", {
                  type: "text",
                  class: "ant-input hidden ss-movimento-input-totalizador",
                  value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.valorTotalImpostos, 2, true),
                  disabled: "true"
                }, null, 8, _hoisted_30)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_a_popover, {
                  placement: "top",
                  title: "Incidência no Total da Nota"
                }, {
                  content: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.incidenciasCalculo, (incidencia, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: incidencia.incidencia + index
                      }, [
                        (incidencia.incidencia === 'TotalNota')
                          ? (_openBlock(), _createBlock(_component_a_checkbox, {
                              key: 0,
                              style: {"margin-left":"0px!important"},
                              checked: incidencia.valor,
                              "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.atualizarValoresTotais()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                              ]),
                              _: 2
                            }, 1032, ["checked", "onUpdate:checked"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_32, [
                      _createTextVNode("Total da Nota "),
                      _createVNode(_component_icone, {
                        class: "ss-icone-informacao-campo",
                        nome: "informacoes-fp"
                      })
                    ]),
                    _createElementVNode("input", {
                      type: "text",
                      class: "ant-input hidden ss-movimento-input-totalizador",
                      style: {"background-color":"#000066","color":"white","font-weight":"bolder"},
                      value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.devolucao.notaFiscal.totalNotaFiscal, 2, true),
                      disabled: "true"
                    }, null, 8, _hoisted_33)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              (_ctx.state.editavel && _ctx.state.recuperarSalvamentoAutomatico)
                ? (_openBlock(), _createBlock(_component_a_alert, {
                    key: 0,
                    type: "warning",
                    "show-icon": "",
                    closable: ""
                  }, {
                    message: _withCtx(() => [
                      _createTextVNode(" Você possui uma versão mais recente deste recebimento salvo de forma automática, deseja recuperar? "),
                      _createVNode(_component_a_button, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.recuperarSalvamentoAutomatico())),
                        size: "small",
                        type: "text"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_card, { titulo: "DOCUMENTO FISCAL" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_a_form_item, {
                        label: "Nº da Nota",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            style: {"text-align":"right"},
                            min: "0",
                            type: "number",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.numeroNotaFiscal) = $event)),
                            disabled: !_ctx.state.editavel,
                            "on:valorDigitado": _cache[10] || (_cache[10] = ($event: any) => (_ctx.salvamentoAutomatico())),
                            onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.validarNumeroNota && _ctx.validarNumeroNota(...args)))
                          }, null, 40, _hoisted_37), [
                            [_vModelText, _ctx.state.devolucao.notaFiscal.numeroNotaFiscal]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_a_form_item, {
                        label: "Série",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.serie) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.salvamentoAutomatico()))
                          }, null, 40, _hoisted_39), [
                            [_vModelText, _ctx.state.devolucao.notaFiscal.serie]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_a_form_item, {
                        label: "Modelo",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_modelo_documento_fiscal, {
                            valor: _ctx.state.devolucao.notaFiscal.modelo,
                            "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.modelo) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.salvamentoAutomatico()))
                          }, null, 8, ["valor", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_a_form_item, {
                        label: "Data de Emissão",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            "hora-minuto-segundo": true,
                            dataSelecionada: _ctx.state.devolucao.notaFiscal.dataEmissao,
                            "onUpdate:dataSelecionada": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.dataEmissao) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.salvamentoAutomatico()))
                          }, null, 8, ["dataSelecionada", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_a_form_item, {
                        label: "Data de Saída",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_data, {
                            "hora-minuto-segundo": true,
                            dataSelecionada: _ctx.state.devolucao.notaFiscal.dataEntradaSaida,
                            "onUpdate:dataSelecionada": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.dataEntradaSaida) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.salvamentoAutomatico()))
                          }, null, 8, ["dataSelecionada", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_a_form_item, {
                        label: "Chave de Acesso",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.chaveAcesso) = $event)),
                            disabled: !_ctx.state.editavel,
                            onKeyup: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.atualizarChaveAcesso && _ctx.atualizarChaveAcesso(...args)))
                          }, null, 40, _hoisted_44), [
                            [_vModelText, _ctx.state.devolucao.notaFiscal.chaveAcesso]
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_a_form_item, {
                        label: "Fornecedor",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_pessoa, {
                            codigoSelecionado: _ctx.state.devolucao.notaFiscal.destinatario.codigoPessoa,
                            "onUpdate:codigoSelecionado": [
                              _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.destinatario.codigoPessoa) = $event)),
                              _ctx.obterEstoquesDisponiveis
                            ],
                            empresas: [_ctx.state.devolucao.codigoEmpresa],
                            recursoOrigem: "DEVOLUCOES_COMPRAS",
                            "tipo-relacao": _ctx.ETipoRelacaoPessoa.Fornecedor,
                            preencherCodigoRelacao: true,
                            codigoRelacao: _ctx.state.codigoFornecedor,
                            "onUpdate:codigoRelacao": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.codigoFornecedor) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _ctx.atualizarInformacoesPessoa
                          }, null, 8, ["codigoSelecionado", "empresas", "tipo-relacao", "codigoRelacao", "disabled", "onUpdate:codigoSelecionado", "onChange"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_a_form_item, {
                        label: "Tipo de Operação",
                        class: "ss-margin-campos",
                        rules: [{ required: true }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_tipo_operacao, {
                            codigoSelecionado: _ctx.state.devolucao.codigoTipoOperacao,
                            "onUpdate:codigoSelecionado": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.devolucao.codigoTipoOperacao) = $event)),
                            tipoMovimento: _ctx.ETipoMovimentoComercial.DevolucaoCompras,
                            empresas: [_ctx.state.devolucao.codigoEmpresa],
                            onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.preencherTipoOperacao(true))),
                            disabled: !_ctx.state.editavel
                          }, null, 8, ["codigoSelecionado", "tipoMovimento", "empresas", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_selecionar_forma_pagamento, {
                        apresentacaoPersonalizada: true,
                        empresas: [_ctx.state.devolucao.codigoEmpresa],
                        tipoMovimento: _ctx.ETipoMovimentoComercial.DevolucaoCompras,
                        codigoSelecionado: _ctx.state.devolucao.codigoFormaPagamento,
                        "onUpdate:codigoSelecionado": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.devolucao.codigoFormaPagamento) = $event)),
                        required: true,
                        disabled: !_ctx.state.editavel,
                        onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.salvamentoAutomatico()))
                      }, null, 8, ["empresas", "tipoMovimento", "codigoSelecionado", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_component_a_form_item, {
                        label: "Marcadores",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_selecionar_marcador_nota_fiscal, {
                            marcadoresSelecionados: _ctx.state.marcadores,
                            "onUpdate:marcadoresSelecionados": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                            disabled: !_ctx.state.editavel,
                            onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.salvamentoAutomatico()))
                          }, null, 8, ["marcadoresSelecionados", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_card, null, {
                default: _withCtx(() => [
                  (_ctx.state.devolucao.codigo !== 0 && _ctx.state.devolucao.codigo !== undefined)
                    ? (_openBlock(), _createBlock(_component_a_tabs, {
                        key: 0,
                        defaultActiveKey: "1"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tab_pane, {
                            key: "1",
                            tab: "ITENS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_devolucao_compras_itens, {
                                empresa: _ctx.state.devolucao.codigoEmpresa,
                                tipoOperacao: _ctx.state.tipoOperacao,
                                dadosPessoaMovimento: _ctx.state.dadosPessoaMovimento,
                                estoquesDisponiveis: _ctx.state.estoquesDisponiveis,
                                pessoa: _ctx.state.devolucao.notaFiscal.destinatario.codigoPessoa,
                                codigoFornecedor: _ctx.state.codigoFornecedor,
                                totalNota: _ctx.state.devolucao.notaFiscal.totalNotaFiscal,
                                itens: _ctx.state.devolucao.itens,
                                documentos: _ctx.state.devolucao.notaFiscal.documentosReferenciadosDfe,
                                editavel: _ctx.state.editavel,
                                onIncluirItens: _ctx.incluirItens,
                                onAtualizarItem: _ctx.atualizarItem,
                                onExcluirItem: _ctx.atualizarValoresTotais
                              }, null, 8, ["empresa", "tipoOperacao", "dadosPessoaMovimento", "estoquesDisponiveis", "pessoa", "codigoFornecedor", "totalNota", "itens", "documentos", "editavel", "onIncluirItens", "onAtualizarItem", "onExcluirItem"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "2",
                            tab: "DOCUMENTOS REFERENCIADOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_documentos_referenciados, {
                                visivel: true,
                                codigoRegistro: _ctx.state.devolucao.codigoNotaFiscal,
                                editavel: _ctx.state.editavel,
                                documentos: _ctx.state.devolucao.notaFiscal.documentosReferenciadosDfe,
                                "onUpdate:documentos": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.documentosReferenciadosDfe) = $event)),
                                onDocumentosAtualizados: _ctx.salvamentoAutomatico
                              }, null, 8, ["codigoRegistro", "editavel", "documentos", "onDocumentosAtualizados"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "3",
                            tab: "IMPOSTOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_impostos, {
                                impostos: _ctx.state.devolucao.notaFiscal.totalImpostos,
                                "onUpdate:impostos": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.totalImpostos) = $event)),
                                incidenciasCalculo: _ctx.state.incidenciasCalculo,
                                "onUpdate:incidenciasCalculo": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.incidenciasCalculo) = $event)),
                                onTotalAlterado: _ctx.atualizarValoresTotais,
                                editavel: _ctx.state.editavel
                              }, null, 8, ["impostos", "incidenciasCalculo", "onTotalAlterado", "editavel"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "4",
                            tab: "FRETE/OUTRAS DESPESAS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_frete, {
                                notaFiscal: _ctx.state.devolucao.notaFiscal,
                                "onUpdate:notaFiscal": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.devolucao.notaFiscal) = $event)),
                                editavel: _ctx.state.editavel,
                                mostrarOutrosValores: true,
                                onTotalAlterado: _ctx.atualizarValoresTotais
                              }, null, 8, ["notaFiscal", "editavel", "onTotalAlterado"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "5",
                            tab: "PAGAMENTO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_devolucao_compras_pagamento, {
                                empresa: _ctx.state.devolucao.codigoEmpresa,
                                totalDetalhesPagamento: _ctx.state.totalDetalhesPagamento,
                                tipoDevolucaoPagamento: _ctx.state.devolucao.tipoDevolucaoPagamento,
                                "onUpdate:tipoDevolucaoPagamento": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.devolucao.tipoDevolucaoPagamento) = $event)),
                                detalhesPagamento: _ctx.state.devolucao.notaFiscal.detalhesPagamento,
                                "onUpdate:detalhesPagamento": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.detalhesPagamento) = $event)),
                                detalheCredito: _ctx.state.detalheCredito,
                                "onUpdate:detalheCredito": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.detalheCredito) = $event)),
                                editavel: _ctx.state.editavel,
                                totalNota: _ctx.state.devolucao.notaFiscal.totalNotaFiscal,
                                onAlterarTipoDevolucao: _ctx.alterarTipoDevolucaoPagamento,
                                onAtualizarDetalhePagamento: _ctx.atualizarDetalhePagamento
                              }, null, 8, ["empresa", "totalDetalhesPagamento", "tipoDevolucaoPagamento", "detalhesPagamento", "detalheCredito", "editavel", "totalNota", "onAlterarTipoDevolucao", "onAtualizarDetalhePagamento"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "6",
                            tab: "DADOS ADICIONAIS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_dados_adicionais, {
                                notaFiscal: _ctx.state.devolucao.notaFiscal,
                                "onUpdate:notaFiscal": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.devolucao.notaFiscal) = $event)),
                                editavel: _ctx.state.editavel,
                                onCampoAlterado: _ctx.salvamentoAutomatico
                              }, null, 8, ["notaFiscal", "editavel", "onCampoAlterado"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "7",
                            tab: "ANEXOS"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_anexos, {
                                codigoRegistro: _ctx.state.devolucao.notaFiscal.codigo,
                                empresa: _ctx.state.devolucao.codigoEmpresa,
                                editavel: _ctx.state.editavel,
                                anexos: _ctx.state.devolucao.notaFiscal.anexos,
                                "onUpdate:anexos": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.devolucao.notaFiscal.anexos) = $event)),
                                onAtualizarAnexo: _ctx.atualizarAnexo,
                                onExcluirAnexo: _ctx.excluirAnexo
                              }, null, 8, ["codigoRegistro", "empresa", "editavel", "anexos", "onAtualizarAnexo", "onExcluirAnexo"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "8",
                            tab: "HISTÓRICO"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_nota_fiscal_historico, {
                                registros: _ctx.state.registrosAtividade
                              }, null, 8, ["registros"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}